import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch';
import fuzzysearch from 'fuzzysearch';
import Breadcrumb from '../../components/Breadcrumb';
import { isMobile } from '../../lib/util';
import Config from '../../config/config';
import './Search.css';
import marked from 'marked';
// import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';
import ScrollableAnchor from 'react-scrollable-anchor';
import { goToAnchor } from 'react-scrollable-anchor';
import LocationItem from '../../components/LocationItem';

let lastQueryStr = "";

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      inputChanged: false,
    };

    this.updateInputValue = this.updateInputValue.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  updateInputValue(evt) {
    this.setState({
      inputValue: evt.target.value,
      inputChanged: true,
    });
  }

  handleClick() {
    if (this.state.inputValue.length > 0 && this.state.inputChanged) {
      this.props.history.push(`/search/${this.state.inputValue}`);
    }
  }

  handleKeyUp(e) {
    // handle enter
    if (e.keyCode === 13) {
      this.handleClick();
    }
  }

  goToAnchorResults() {
    const queryStr = this.props.match.params.query.toLowerCase();

    if(queryStr && lastQueryStr !== queryStr){
      setTimeout( () => goToAnchor('search-results'), 300);
      lastQueryStr = queryStr;
    }
  }

  componentDidMount() {
    this.goToAnchorResults();
  }

  componentDidUpdate() {
    this.goToAnchorResults();
  }

  fuzzySearch(needle, haystack) {
    // console.log('needle, haystack', needle, haystack);
    if(typeof haystack !== 'string'){
      return false
    }

    haystack = haystack.toLowerCase();
    let result = false;
    if(needle instanceof Array){
      result = needle.every(query => fuzzysearch(query.toLowerCase(), haystack));
    }else{
      result = fuzzysearch(needle.toLowerCase(), haystack);
    }
    return result;
  }

  normalSearch(needle, haystack) {
    if(typeof haystack !== 'string'){
      return false
    }

    haystack = haystack.toLowerCase();
    let result = false;
    if(needle instanceof Array){
      result = needle.every(query => haystack.indexOf(query.toLowerCase()) !== -1);
    }else{
      result = haystack.indexOf(needle.toLowerCase()) !== -1;
    }
    return result;
  }

  render() {
    const queryStr = this.props.match.params.query.toLowerCase();
    const isLoaded = this.props.products.length > 0 &&
      this.props.news.length > 0 &&
      this.props.locations.length > 0;
    const renderProductsResult = [];
    const renderNewsResult = [];
    const renderLocationsResult = [];
    const queryArray = queryStr.split(" ");

    let parsedData;
    if (queryStr) {
      parsedData = {
        products: this.props.products.filter((elem) => {
          let titles = [];
          if(elem.title){
            titles.push(elem.title);
          }
          if(elem.chinese_title){
            titles.push(elem.chinese_title);
          }

          let haystack = titles.join(" ");
          if(elem.description){
            haystack += elem.description;
          }

          const matchTitle = titles.length > 0 && this.fuzzySearch(queryArray, titles.join(" "));
          const matchDescription = this.normalSearch(queryArray, elem.description);
          return matchTitle || matchDescription;

          // return this.fuzzySearch(queryArray, haystack);
        }),
        news: this.props.news.filter((elem) => {
          let haystack = "";
          if(elem.title){
            haystack += elem.title;
          }
          if(elem.content){
            haystack += elem.content;
          }

          // return this.fuzzySearch(queryArray, haystack);

          const matchTitle = elem.title && this.fuzzySearch(queryArray, elem.title);
          const matchContent = elem.content && this.normalSearch(queryArray, elem.content);
          return matchTitle || matchContent;
        }),
        locations: this.props.locations.filter((elem) => {
          let haystack = "";
          if(elem.title){
            haystack += elem.title;
          }
          if(elem.address){
            haystack += elem.address;
          }

          // return this.fuzzySearch(queryArray, haystack);

          const matchTitle = elem.title && this.fuzzySearch(queryArray, elem.title);
          const matchAddress = elem.address && this.normalSearch(queryArray, elem.address);
          return matchTitle || matchAddress;
        }),
      };
    }
    if (parsedData) {
      Object.keys(parsedData).forEach((key) => {
        let linkPrefix;
        switch (key) {
          case 'products':
            linkPrefix = '/product';
            break;
          case 'news':
            linkPrefix = '/news';
            break;
          case 'locations':
            linkPrefix = '/locations';
            break;
          default:
            throw new Error('unexpected key in Search.js');
        }
        if (parsedData[key].length > 0) {
          switch (key) {
            case 'products':
              renderProductsResult.push((
                <div key="title-products" className="title-wrapper">
                  <div  className="title stihl-title">產品</div>
                </div>
              ));
              break;
            case 'news':
              renderNewsResult.push((
                <div key="title-products" className="title-wrapper">
                  <div key="title-news" className="title stihl-title">最新消息</div>
                </div>
              ));
              break;
            case 'locations':
              renderLocationsResult.push((
                <div key="title-products" className="title-wrapper">
                  <div key="title-locations" className="title stihl-title">銷售據點</div>
                </div>
              ));
              break;
            default:
              throw new Error('unexpected key in Search.js');
          }
        }
        parsedData[key].forEach((elem, idx) => {
          let linkStr;
          let arr = [];
          let content = null;

          if (key === 'products') {
            linkStr = `${linkPrefix}/${elem.product_ID}`;
            arr = renderProductsResult;
            if(elem.description) {
              content = <p dangerouslySetInnerHTML={{ __html: marked(elem.description) }} />;
            }
          }
          if (key === 'news') {
            linkStr = `${linkPrefix}/detail/${elem.id}`;
            arr = renderNewsResult;
            let news_content = elem.content;
            if (news_content.length > 200) {
              news_content = `${news_content.slice(0, 197)}...`;
            }

            if(news_content) {
              content = <p dangerouslySetInnerHTML={{ __html: marked(news_content) }} />;
            }
          }
          if (key === 'locations') {
            linkStr = `${linkPrefix}/${elem.locationarea.name}`;
            arr = renderLocationsResult;
          }


          if(arr){
            if(key === 'locations'){
              arr.push(<LocationItem key={`location-item-${idx}`} data={elem}/>);
            }else{
              arr.push((
                <div className="media-wrapper" key={`${key}${idx}`}>
                <article  className="media" onClick={() => {this.props.history.push(linkStr)}}>
                  <figure className="media-left">
                    <div className={`image is-64x64 icon-${key === 'news' ? ('news-' + elem.newstype.name) : key}`} 
                      style={elem.image && elem.image.length > 0 ? {
                        backgroundImage: `url(${Config.apiUrl}${elem.image[0].url})`
                      } : null}/>
                  </figure>
                  <div className="media-content">
                    <div className="content">
                      <Link to={linkStr}>
                        <h4>{key === 'news' ? elem.title : elem.name}</h4>
                        {key === 'products' && <h4>{elem.chinese_title}</h4> }
                      </Link>
                      { !isMobile() && content }
                    </div>
                  </div>
                </article>

                  { isMobile() && 
                    <div className="media-content-mobile">
                      <div className="content">
                        {content}
                      </div>
                    </div>
                  }
                </div>
              ));
            }
          }
        });
      });
    }

    const hasResult = renderProductsResult.length > 0 || renderNewsResult.length > 0 || renderLocationsResult.length > 0;

    return (
      <section className="section">
        <ScrollableAnchor id={'search-results'}>
          <div className="search container">
            <Breadcrumb {...this.props} />
            <div className="outter-container">
              <div className="inner-container">
                {!isMobile() && (
                  <div className="field has-addons search-field">
                    <p className="control">
                      <input
                        className="input"
                        type="text"
                        placeholder="搜尋：產品名稱、銷售據點、最新消息"
                        value={this.state.inputChanged ? this.state.inputValue : queryStr}
                        onChange={this.updateInputValue}
                        onKeyUp={this.handleKeyUp}
                      />
                    </p>
                    <p className="control">
                      <button className="button" onClick={this.handleClick}>
                        <span className="icon">
                          <FontAwesomeIcon icon={faSearch} />
                        </span>
                      </button>
                    </p>
                  </div>
                )}
                {renderProductsResult.length > 0 && <div className="search-result search-products-result">{renderProductsResult}</div>}
                {renderNewsResult.length > 0 && <div className="search-result search-news-result">{renderNewsResult}</div>}
                {renderLocationsResult.length > 0 && <div className="search-result search-locations-result">{renderLocationsResult}</div>}
                {hasResult && !isLoaded && (
                  <div className="hero">
                    <div className="hero-body">
                      <div className="container">
                        <h1 className="title">
                          讀取資料中...
                        </h1>
                      </div>
                    </div>
                  </div>
                )}
                {!hasResult && isLoaded && (
                  <div className="hero">
                    <div className="hero-body">
                      <div className="container">
                        <h1 className="title">
                          找不到相關資料
                        </h1>
                        <h2 className="subtitle">
                          請搜尋其他關鍵字
                        </h2>
                      </div>
                    </div>
                  </div>
                )}
              </div> 
            </div>  
          </div>
        </ScrollableAnchor>
      </section>
    );
  }
}

Search.propTypes = {
  news: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      query: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

Search.defaultProps = {
  match: {
    params: {
      query: '',
    },
  },
  history: {
    push: () => {},
  },
};

const mapStateToProps = state => ({
  news: state.news,
  products: state.products,
  locations: state.locations,
});

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./src/containers/page/Search.js